export class Alert {
  type?: AlertType
  message?: string

  links?: Link[]

  id?: string

  constructor(init?: Partial<Alert>) {
    Object.assign(this, init)
  }
}

export enum AlertType {
  Succes,
  Error,
  Info,
  Warning,
}

export interface Link {
  title: string
  link: string
}
